<style scoped>
.mtitle {
  font-size: 12pt;
  font-weight: 700
}
/* .follower-section {
  height: 50vh
} */
.loader-block {
  padding-top: 50px;
  position:relative;
}
</style>


<template>
  <ModalHolder :title="title" m-height="62vh" :is-show="isShow">
    <template slot="mheader">
      <div class="flex-container direction-row center" style="justify-content:space-between;">
        <div></div>
        <b>{{ title }}</b>
        <img alt=" " @click="close()" style="height:25px; width:25px;" src="@/assets/close.png">
      </div>
    </template>
    <template slot='mcontent'>
      <div class="follower-section" v-if='data'>
        <div class="loader-block" v-if='isLoading'>
          <Spin size="large" fix></Spin>
        </div>
        <Row type="flex" justify="center" v-if="'subscribers' in data">
          <i-col v-if="data.subscribers.length > 0" :span="24" v-for="(item, k) in data.subscribers" :key="k">
            <UserListItemComponent @userClick='close' :item="item"></UserListItemComponent>
          </i-col>
          <i-col v-if="data.subscribers.length <= 0" :span="24">
            <p align="center" style="padding:20px 0;color:#aaa"><b>0 {{type}}</b></p>
          </i-col>
          <i-col v-if="data.subscribers.length < data.total" :span="24">
            <Button style="width:50%;display:flex;margin: 5px auto;justify-content:center;backgroundColor:white" @click="loadMore" default :loading="isLoadingMore">
              <span v-if="!isLoadingMore" style="color:#2d8cf0">Load More</span>
              <span v-else>Loading...</span>
            </Button>
          </i-col>
        </Row>
      </div>
    </template>
    <template slot='mfooter'>
      <Button @click='close'>Close</Button>
    </template>
  </ModalHolder>
</template>

<script>
import ModalHolder from "@/components/ModalHolderComponent";
import UserListItemComponent from '@/components/UserListItemComponent'

export default {
  name: 'user-follow-list-component',
  components: {
    UserListItemComponent,
    ModalHolder
  },
  data() {
    return {
    }
  },
  computed: {
    isShow: {
      get() {
        return this.$store.state.follow.show;
      },
      set() {
        this.$store.commit('follow/hide');
      }
    },
    type() {
      return this.$store.state.follow.type;
    },
    userId() {
      return this.$store.state.follow.userId;
    },
    isLoading() {
      return this.$store.state.follow.isLoading;
    },
    isLoadingMore() {
      return this.$store.state.follow.isLoadingMore
    },
    data() {
      if (this.type == 'followers') {
        return this.$store.state.follow.userFollowers
      } else if (this.type == 'following') {
        return this.$store.state.follow.userFollowing
      }
    },
    title() {
      if (this.type == 'followers') return 'Followers'
      else if (this.type == 'following') return 'Following'
    }
  },
  watch: {
    isShow: function(n, o) {
      if(n) {
        if (this.type == 'followers') this.$store.dispatch('follow/getUserFollowers', {id:this.userId})
        else if (this.type == 'following') this.$store.dispatch('follow/getUserFollowing', {id:this.userId})
      }
    }
  },
  methods: {
    close() {
      this.isShow = false
    },
    loadMore() {
      if (this.type == 'followers') this.$store.dispatch('follow/getUserFollowersNextPage', {id:this.userId})
      else if (this.type == 'following') this.$store.dispatch('follow/getUserFollowingNextPage', {id:this.userId})
    }
  }
}
</script>
